<template>
    <kiosk-layout formContainer>
        <page-loading v-if="loading"></page-loading>
        <div v-else>
            <page-header class="mb-6 lg:mb-12">
                <template v-slot:subtitle>
                    <a href="/kiosk/migrations" class="no-underline! text-sky-600! text-base font-normal">
                        <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                        Back to Migrations
                    </a>
                </template>

                Migration {{ migration.id }}
            </page-header>

            <div class="grid grid-cols-12">
                <page-sidebar :links="navigationLinks"></page-sidebar>

                <slot></slot>
            </div>
        </div>
    </kiosk-layout>
</template>

<script setup>
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onMounted, computed } from 'vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { useMigrationDetails } from '../composables/useMigrationDetails';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';

const props = defineProps({
    migrationId: {
        type: Number,
        required: true,
    },
});

const { mount, migration, loading } = useMigrationDetails();

const navigationLinks = computed(() => [
    { href: `/kiosk/migrations/${props.migrationId}`, label: 'Details' },
    { href: `/kiosk/migrations/${props.migrationId}/config`, label: 'Config' },
]);

onMounted(() => {
    mount(props.migrationId);
});
</script>
